"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxGroupFormLabel = void 0;
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    label: {
      fontSize: "12px",
      marginBottom: theme.spacing(1)
    }
  };
});
var CheckboxGroupFormLabel = exports.CheckboxGroupFormLabel = function CheckboxGroupFormLabel(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.FormLabel, _objectSpread(_objectSpread({
    "data-cy-role": "checkboxGroupLabel",
    className: classes.label,
    focused: false
  }, props), {}, {
    children: children
  }));
};
CheckboxGroupFormLabel.propTypes = {
  /**
   * 	The content of the component.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].array, _propTypes["default"].func]),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * The color of the component.
   * It supports those theme colors that make sense for this component.
   */
  color: _propTypes["default"].oneOf(["primary", "secondary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes["default"].oneOfType([_propTypes["default"].elementType, _propTypes["default"].string]),
  /**
   * If true, the label should be displayed in a disabled state.
   */
  disabled: _propTypes["default"].bool,
  /**
   * If true, the label should be displayed in an error state.
   */
  error: _propTypes["default"].bool,
  /**
   * If true, the label should use filled classes key.
   */
  filled: _propTypes["default"].bool,
  /**
   * If true, the input of this label is focused (used by FormGroup components).
   */

  focused: _propTypes["default"].bool,
  /**
   * If true, the label will indicate that the input is required.
   */

  required: _propTypes["default"].bool
};